export const columns = [
  {
    id: 'codigo-material',
    displayName: 'Codigo - Material'
  },
  {
    id: 'codigo-loja',
    displayName: 'Codigo - Loja'
  },
  {
    id: 'codigo-fornecedor',
    displayName: 'Codigo - Fornecedor'
  },
  {
    id: 'quantidade-desejada',
    displayName: 'Quantidade Desejada'
  },
  {
    id: 'tipo-pedido',
    displayName: 'Tipo - Pedido'
  },
  {
    id: 'tipo-data',
    displayName: 'Tipo - Data'
  },
  {
    id: 'data-remessa',
    displayName: 'Data - Remessa'
  },
  {
    id: 'desconto',
    displayName: 'Desconto'
  },
  {
    id: 'forma-pagamento',
    displayName: 'Forma de Pagamento'
  }
]

export const unitToInt = [
  'BL',
  'CH',
  'CJ',
  'CLL',
  'CX',
  'FL',
  'FR',
  'GAL',
  'JG',
  'M',
  'PAC',
  'PAR',
  'PC',
  'RL',
  'SAC',
  'TAM',
  'UN'
]
